import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {ReceivablesJob} from "../interface/receivables-job";
import {HiperioCredentialsJob} from "../interface/hiperio-credentials-job";
import {HiperioUserJob} from "../interface/hiperio-user-job";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {first} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class HiperioUserJobsService {
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<HiperioUserJob>>
    = new ReplaySubject<CountedAndPaginated<HiperioUserJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadJobList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/hiperio/user-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<HiperioUserJob>) => {
        this.jobListSubject.next(result);
      });
  }

  public restart(uuid: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/user-job/${uuid}/restart`, {})
      .pipe(first());
  }

  updateAccountCreated(uuid: string, formData:
  {accountCreated: boolean}): Observable<any> {
    return this.httpClient.put(`/rest/crm/hiperio/user-job/${uuid}/accountCreated`, formData)
      .pipe(first());
  }
}
